import React from "react";

import { StyledSVG } from "../StyledIcon";

export const CraftIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_1048_437)">
        <rect width="40" height="40" vectorEffect="non-scaling-stroke" />
        <path
          d="M10.3393 24.7587L9.609 24.9296L9.609 24.9296L10.3393 24.7587ZM5.96817 6.082L6.13908 5.35174C5.88649 5.29262 5.62128 5.36823 5.43784 5.55167C5.2544 5.73511 5.17879 6.00032 5.2379 6.25291L5.96817 6.082ZM18.9853 30.8897L19.0656 31.6354L19.0656 31.6354L18.9853 30.8897ZM24.3733 30.3094L24.9037 29.7791C24.7432 29.6186 24.5187 29.5395 24.293 29.5638L24.3733 30.3094ZM29.1662 35.1023L28.6359 35.6326C28.9287 35.9255 29.4036 35.9255 29.6965 35.6326L29.1662 35.1023ZM34.9885 29.28L35.5188 29.8103C35.6594 29.6697 35.7385 29.4789 35.7385 29.28C35.7385 29.0811 35.6594 28.8903 35.5188 28.7497L34.9885 29.28ZM30.1956 24.4871L29.4499 24.4068C29.4256 24.6325 29.5048 24.857 29.6653 25.0175L30.1956 24.4871ZM30.7758 19.0992L30.0301 19.0189L30.7758 19.0992ZM24.6449 10.4531L24.474 11.1834L24.6449 10.4531ZM11.0695 24.5878L6.69844 5.91109L5.2379 6.25291L9.609 24.9296L11.0695 24.5878ZM18.905 30.144C15.265 30.536 11.9038 28.1526 11.0695 24.5878L9.609 24.9296C10.6159 29.2319 14.6724 32.1084 19.0656 31.6354L18.905 30.144ZM24.293 29.5638L18.905 30.144L19.0656 31.6354L24.4536 31.0551L24.293 29.5638ZM29.6965 34.5719L24.9037 29.7791L23.843 30.8398L28.6359 35.6326L29.6965 34.5719ZM34.4581 28.7497L28.6359 34.5719L29.6965 35.6326L35.5188 29.8103L34.4581 28.7497ZM29.6653 25.0175L34.4581 29.8103L35.5188 28.7497L30.7259 23.9568L29.6653 25.0175ZM30.0301 19.0189L29.4499 24.4068L30.9413 24.5674L31.5215 19.1795L30.0301 19.0189ZM24.474 11.1834C28.0387 12.0177 30.4221 15.3788 30.0301 19.0189L31.5215 19.1795C31.9946 14.7863 29.1181 10.7298 24.8158 9.72284L24.474 11.1834ZM5.79726 6.81227L24.474 11.1834L24.8158 9.72284L6.13908 5.35174L5.79726 6.81227Z"
          fill={iconColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M22.5209 22.6723L6.86011 7.01147"
          stroke={iconColor}
          vectorEffect="non-scaling-stroke"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="22.5209"
          cy="22.6724"
          r="1.67794"
          transform="rotate(-45 22.5209 22.6724)"
          fill={iconColor}
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <defs>
        <clipPath id="clip0_1048_437">
          <rect width="40" height="40" vectorEffect="non-scaling-stroke" />
        </clipPath>
      </defs>
    </StyledSVG>
  );
};
